import React from 'react';
import { Layout, Avatar, Dropdown, Menu } from 'antd';
import {
    UserOutlined,
    LogoutOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Header: AntHeader } = Layout;

const Header: React.FC = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        // Xử lý đăng xuất
        localStorage.removeItem('user');
        navigate('/login');
    };

    const userMenu = (
        <Menu>
            <Menu.Item
                key="logout"
                icon={<LogoutOutlined />}
                onClick={handleLogout}
                danger
            >
                Đăng Xuất
            </Menu.Item>
        </Menu>
    );

    return (
        <AntHeader
            className="bg-white shadow-md flex justify-end items-center px-6"
            style={{ position: 'fixed', width: 'calc(100% - 250px)', right: 0, top: 0, zIndex: 1 }}
        >
            <div className="flex items-center space-x-4">
                <Dropdown overlay={userMenu} placement="bottomRight">
                    <div className="cursor-pointer flex items-center">
                        <Avatar
                            icon={<UserOutlined />}
                            className="mr-2"
                        />
                        <span className="font-medium">Admin</span>
                    </div>
                </Dropdown>
            </div>
        </AntHeader>
    );
};

export default Header;